import { ReactElement, useEffect, useRef } from 'react';
import { useToggle } from '@client/common/hooks';
import { ModifyNewsletters } from '@client/myAccount/newsletters/components/ModifyNewsletters/ModifyNewsletters';
import { useClearUpdateNewslettersAction, useUpdateNewslettersData } from '@client/myAccount/newsletters/hooks';
import { Props } from './ModifyNewslettersContainer.types';

const ANIMATION_DURATION = 250;

export const ModifyNewslettersContainer = ({ wereCheckboxesChanged }: Props): ReactElement => {
  const [isModalOpened, setIsModalOpened] = useToggle();
  const updateNewslettersData = useUpdateNewslettersData();
  const clearUpdateNewslettersAction = useClearUpdateNewslettersAction();
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);

  const handleButtonClick = (): void => {
    setIsModalOpened(true);
  };

  const handleModalClose = (): void => {
    setIsModalOpened(false);

    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    timeoutRef.current = setTimeout((): void => {
      clearUpdateNewslettersAction();
    }, ANIMATION_DURATION);
  };

  const isSubmitting = updateNewslettersData.wasStarted && updateNewslettersData.isLoading;

  const isModalVisible = isModalOpened && (updateNewslettersData.isLoaded || updateNewslettersData.hasFailed);


  useEffect(() => () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
  }, []);

  return (
    <ModifyNewsletters
      wereCheckboxesChanged={wereCheckboxesChanged}
      isModalVisible={isModalVisible}
      isSubmitting={isSubmitting}
      onButtonClick={handleButtonClick}
      onModalClose={handleModalClose}
      updateNewslettersData={updateNewslettersData}
    />
  );
};
